import React from "react";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";

// Create a styled version of the MUI Tab that applies the desired defaults.
const StyledTab = styled(Tab)(({ theme }) => ({
  fontFamily: ["Open Sans", "sans-serif"].join(","),
  fontSize: "16px",
  borderRadius: "12px 12px 0 0",

  color: theme.palette.primary.text2,
  "&.Mui-selected": {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
}));

// CustomTab simply renders StyledTab with any props passed in.
const CustomTab = (props) => {
  return <StyledTab {...props} />;
};

export default CustomTab;
